module.exports = __webpack_public_path__ + "img/yousuke.784a6cfb.jpg";